import Typography from '../../Typography';

export interface MenuLabelProps {
  children: React.ReactNode;
  className?: string;
}

const MenuLabel = ({ children, className }: MenuLabelProps) => {
  return (
    <Typography color='secondary' className={className}>
      {children}
    </Typography>
  );
};

export default MenuLabel;
